import { Box, InputLeftElement } from "@chakra-ui/react";
import React from "react";
import { InputControl } from "../forms";
import { MaterialIcon } from "./MaterialIcon";

interface IProps {
  search: string;
  placeholder: string;
  setSearch: (search: string) => void;
}

const SearchInput = ({ search, setSearch, placeholder }: IProps) => {
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return (
    <Box>
      <InputControl
        maxW="24rem"
        value={search}
        name="search"
        placeholder={placeholder}
        type="search"
        onChange={handleOnChange}
        inputLeftElement={
          <InputLeftElement
            pointerEvents="none"
            children={
              <MaterialIcon name="search" fontSize="1rem" variant="outline" />
            }
          />
        }
      />
    </Box>
  );
};

export default SearchInput;
